import { memo, useRef, useLayoutEffect, useContext } from 'react';
import { getBannerList } from '@/apis';
import { useQuery } from '@tanstack/react-query';
// import { Carousel } from 'antd';
import { Spin } from 'antd';
import cls from 'classnames';
import styles from './index.module.scss';
import type { InferArrayValue } from '@/types/infer';
import { useNavigate } from 'react-router-dom';
import Splide from '@splidejs/splide';
import globalContext from '@/configs/globalContext';

export enum BannerType {
  // 无
  'none',
  // 商品详情
  'detail',
  // 跳转链接
  'link',
  // 视频
  'video',
}

export type BannerItem = InferArrayValue<
  NonNullable<Awaited<ReturnType<typeof getBannerList>>['data']>
>;

const Banner = () => {
  const { isMobile } = useContext(globalContext);
  const navigate = useNavigate();
  const bannerSplideRef = useRef<HTMLDivElement>(null);
  const { data: bannerlist, isFetching } = useQuery([getBannerList.name], () =>
    getBannerList({
      page: 1,
      page_size: 500,
    }).then((res) => {
      const list = res?.data || [];
      return list.sort((b, a) => (a.weight ?? 0) - (b.weight ?? 0));
    }),
  );
  const handleClick = (item: BannerItem): void => {
    if (item.banner_type === BannerType.link) {
      window.open(item.banner_ticket, '_blank');
    } else if (item.banner_type === BannerType.detail) {
      navigate(`/product/${item.banner_ticket}`);
    }
  };

  const screenWidth =
    window.screen.width ||
    document.documentElement.clientWidth ||
    window.innerWidth;
  const devicePixelRatio = window.devicePixelRatio || 1;
  const physicalScreenWidth = Math.ceil(screenWidth * devicePixelRatio);
  const suffix = `?x-oss-process=image/resize,m_lfit,w_${physicalScreenWidth}`;

  useLayoutEffect(() => {
    let stanceSplide: Splide;

    if (bannerSplideRef.current) {
      stanceSplide = new Splide(bannerSplideRef.current, {
        // preload: true,
        autoHeight: true,
        width: '100%',
        perPage: 1,
        type: 'loop',
        autoplay: true,
        pagination: true,
        lazyLoad: true,
        isNavigation: true,
      });
      stanceSplide.mount();
    }

    return () => {
      stanceSplide?.destroy();
    };
  }, [bannerlist]);
  return (
    <div className={styles.swiper}>
      <Spin
        className="center-loading"
        delay={300}
        spinning={isFetching}
        size="large"
      />
      <div ref={bannerSplideRef} className={cls('splide', styles.bannerSplide)}>
        <div className="splide__track">
          <ul className="splide__list">
            {!!bannerlist &&
              bannerlist.map((item) => (
                <li
                  key={item.id}
                  className={cls(
                    'splide__slide',
                    styles.item,
                    item.banner_type === BannerType.link ||
                      item.banner_type === BannerType.detail
                      ? 'can-click'
                      : '',
                  )}
                  onClick={() => handleClick(item)}
                >
                  <img
                    className={styles.itemImg}
                    src={
                      isMobile && item.mobile_banner_img
                        ? `${item.mobile_banner_img}${suffix}`
                        : `${item.banner_img}${suffix}`
                    }
                    alt="banner图片"
                  />
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default memo(Banner);
